import * as React from 'react';
import { Typography } from '../typography';
import { Icon } from '../icon';
import clsx from 'clsx';
import Link from 'next/link';

interface LabelFileUploadedI {
	label: string;
	icon: string;
	iconClassName?: string;
	iconType?: 'button' | 'link';
	hrefLink?: string;
	className?: string;
	onClick?: () => void;
}

export const LabelFileUploaded: React.FC<LabelFileUploadedI> = ({
	label,
	icon,
	iconClassName,
	iconType = 'button',
	hrefLink,
	className,
	onClick,
}) => {
	return (
		<div
			className={clsx(
				'flex items-centers px-3 py-2 bg-gray-5 rounded-xl justify-between gap-2 w-fit mb-2 min-w-[154px]',
				className
			)}
		>
			<Typography
				type="regular-10"
				className="opacity-60 text-center truncate max-w-[106px]"
			>
				{label}
			</Typography>

			{iconType === 'button' ? (
				<button type="button" onClick={onClick}>
					<Icon
						src={icon}
						className={clsx('!size-4 text-main-red', iconClassName)}
					/>
				</button>
			) : (
				hrefLink && (
					<Link target="_blank" href={hrefLink}>
						<Icon
							src={icon}
							className={clsx('!size-4 text-main-red', iconClassName)}
						/>
					</Link>
				)
			)}
		</div>
	);
};
